import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  // Auth
  LoginPage,
  ResetPasswordPage,
  NewPasswordPage,
  // voice_page
  BlankPage,
} from './elements';
import Page404 from '../pages/Page404';
import CompactLayout from '../layouts/compact';
import ComingSoonPage from '../pages/ComingSoonPage';
import MaintenancePage from '../pages/MaintenancePage';
import Page500 from '../pages/Page500';
import Page403 from '../pages/Page403';
import GeneralBookingPage from '../pages/dashboard/GeneralBookingPage';

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <GeneralBookingPage />, index: true },
        { path: 'dashboard', children: [{ path: 'blank', element: <BlankPage /> }] },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        {
          path: 'auth/reset-password',
          element: (
            <GuestGuard>
              <ResetPasswordPage />
            </GuestGuard>
          ),
        },
        {
          path: 'auth/new-password',
          element: (
            <GuestGuard>
              <NewPasswordPage />
            </GuestGuard>
          ),
        },
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
